<!--Validación del estado de la conexión-->
@if (isSlowConnection) {
  <div class="alert">
    ⚠ La conexión de internet es lenta.
  </div>
}

<app-page-title [title]="title()"></app-page-title>
<app-page-loader [load]="pageLoad" [label]="title()" (retry)="init()"></app-page-loader>

<div class="header">

  <!-- Selector de sitio → almacén, indicadores y cambio de vista.
       El selector es el del toolbar, igual que en Inventario de instrumental,
       para que los tres módulos se vean y se usen igual. Sustituyó a la
       tarjeta-acordeón "Selección de almacén"; `inventoryForm` se conserva
       porque el resto del componente lee de ahí el almacén, pero ahora lo
       llena `onScopeChange()`. -->
  <app-inventory-toolbar
    [places]="placesList"
    [warehouses]="warehousesList"
    [kpis]="kpis"
    [activeKpi]="activeKpi"
    [viewMode]="viewMode"
    storageKey="products"
    [showViewToggle]="false"
    (scopeChange)="onScopeChange($event)"
    (kpiToggle)="onKpiToggle($event)"
    (viewModeChange)="onViewModeChange($event)">
  </app-inventory-toolbar>



  <div class="filter-bar">
    <div class="filter-card">
      <app-search-pill placeholder="Código, descripción, lote, RFID…" (search)="applyFilter($event)"></app-search-pill>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Estatus de inventario</mat-label>
        <mat-select [(value)]="invStatus" (selectionChange)="statusFilter($event)">
          <mat-option value="Limpiar">Todos</mat-option>
          @for (status of statuses; track status) {
            <mat-option [value]="status">{{status}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <span class="filter-card__spacer"></span>
      <mat-button-toggle-group class="view-toggle" [value]="viewMode" (change)="onViewModeChange($event.value)" [hideSingleSelectionIndicator]="true" aria-label="Vista">
        <mat-button-toggle value="table" matTooltip="Vista de tabla"><mat-icon>table_rows</mat-icon></mat-button-toggle>
        <mat-button-toggle value="cards" matTooltip="Vista de tarjetas"><mat-icon>grid_view</mat-icon></mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <app-filter-chips [chips]="statusChips" [count]="totalRows" [total]="kpiCounts.total" noun="piezas" (remove)="clearStatus()" (clear)="clearStatus()"></app-filter-chips>
  </div>
</div>

<div class="list-actions">
  <button mat-stroked-button (click)="pageLoad.refresh(getEntityData())"><mat-icon>refresh</mat-icon> Actualizar</button>
  <button mat-stroked-button [disabled]="btnSelectionWarehouse || exporting" (click)="downloadInventoryWorkbook()"
          matTooltip="Un solo Excel: inventario, agrupado por código y lote, próximos a caducar y merma">
    <mat-icon>download</mat-icon> {{ exporting ? 'Generando…' : 'Descargar Excel' }}
  </button>
  <button mat-stroked-button (click)="openInventoryControl()" matTooltip="Formato GA por turno: recibido, consumo, DLV y entregó">
    <mat-icon>print</mat-icon> Control de inventario
  </button>
  @if (aduanaStock.length > 0 && permissions['create'] && this.inventoryForm.controls['warehouse'].value !== 'Todos') {
    <button mat-stroked-button color="primary" [disabled]="btnSelectionWarehouse" (click)="openAduanaMaterial()"><mat-icon>pending</mat-icon> Confirmación de recepción</button>
  }
</div>

@if (scopeReady) {
  <app-selection-bar [count]="selectedRows.length" (export)="exportSelection()" (clear)="clearSelection()"></app-selection-bar>
}

<div class="indicators">
  <div class="dark-status">
    <span><b>{{ totalRows | number }} pieza(s)</b></span>
  </div>
  <!-- Paginado en el servidor: 100 por página; los indicadores cuentan todo el locker. -->
  <mat-paginator class="spacer" [length]="totalRows" [pageSize]="pageSize" [pageIndex]="pageIndex"
                 [pageSizeOptions]="[100, 200, 500]" showFirstLastButtons (page)="onPage($event)"></mat-paginator>
</div>
@if (kpiCounts.caduco>0) {
  <div class="red-status">
    <span><b>Insumos caducos: {{kpiCounts.caduco}}</b></span>
  </div>
}
@if (wasteList.length>0) {
  <div class="blue-status">
    <span><b>Insumos merma: {{wasteList.length}}</b></span>
  </div>
}
@if (kpiCounts.maleta>0) {
  <div class="yellow-status">
    <span><b>Insumos de maleta: {{kpiCounts.maleta}}</b></span>
  </div>
}

@if (aduanaStock.length>0 && permissions['create']) {
  <div class="alert">
    ⚠ Hay material en aduana para este locker. Por favor revise la confirmación de recepción.
  </div>
}


<!-- ── Vista de tarjetas ───────────────────────────────────────────── -->
@if (scopeReady && viewMode === 'cards') {
  <div class="inv-cards cat-cards">
    @for (item of filteredList; track item.id) {
      <div class="cat-card" [class.cat-card--selected]="selection.isSelected(item)">
        <div class="cat-card__photo">
          @if (productImages[item.product]) {<img [src]="productImages[item.product]" alt="Foto" loading="lazy">} @else {<mat-icon>image_not_supported</mat-icon>}
        </div>
        <div class="cat-card__head">
          <mat-checkbox color="primary" [checked]="selection.isSelected(item)" (change)="selection.toggle(item)" matTooltip="Seleccionar"></mat-checkbox>
          <span class="cat-card__title">{{ item.code || item._product || 'Sin código' }}</span>
          <span class="inv-status" [attr.data-status]="item.status">{{ item.status || '—' }}</span>
        </div>
        <div class="cat-card__body">
            <div class="cat-card__field"><span class="cat-card__label">Descripción:</span><span class="cat-card__value">{{ item.description || item._description || '—' }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Lote:</span><span class="cat-card__value">{{ item.batch || '—' }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Caducidad:</span><span class="cat-card__value"><span class="semaphore" [attr.data-tone]="expiryTone(item.expiration)" [matTooltip]="expiryHint(item.expiration)"><span class="semaphore__dot"></span>{{ item.expiration || '—' }}</span></span></div>
            <div class="cat-card__field"><span class="cat-card__label">RFID:</span><span class="cat-card__value">{{ item.tagRfid || '—' }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Tipo:</span><span class="cat-card__value">{{ item.type || '—' }}</span></div>
        </div>
        @if (cardActions[item.id]?.length) {
          <div class="cat-card__actions">
            @for (a of cardActions[item.id]; track a.icon) {
              <button mat-icon-button color="primary" [matTooltip]="a.tooltip" (click)="handleCardAction(a.content)"><mat-icon>{{ a.icon }}</mat-icon></button>
            }
          </div>
        }
      </div>
    }
    @if (filteredList.length === 0) {
      <p class="inv-cards__empty">No hay existencias que coincidan con el filtro.</p>
    }
  </div>
}


@if (scopeReady && viewMode === 'table' && tableData.data.length>0) {
  <app-custom-table
    [tableData]="tableData"
    [selectable]="true"
    [selectionModel]="selection"
    (selectionChange)="selectedRows = $event"
    [filters]="tableFilters"
    (actionClicked)="handleCardAction($event)">
  </app-custom-table>
}